import React, { useRef, useState } from "react";
import TranspaleStringToComponente from "./TranspaleStringToComponente";
import { Label } from "reactstrap";

const DragDropReorderTable = ({ items = [], callbackItems = () => {} }) => {

  const [hiddenCheckbox, setHiddenCheckbox] = useState(false);
  const [dragIndex, setDragIndex] = useState(null);

  const handleDragStart = (index) => {
    setDragIndex(index);
  };

  const moveItem = (from, to) => {
    if (to < 0 || to >= items.length || !items[to].draggable) return;

    const newItems = [...items];
    const [item] = newItems.splice(from, 1);
    newItems.splice(to, 0, item);

    callbackItems(newItems);
    setDragIndex(to);
  };

  const handleMoveItem = (dropIndex) => {
    if (dragIndex === null || dragIndex === dropIndex) return;

    moveItem(dragIndex, dropIndex);
    setDragIndex(null);
  };

  return (
    <div className="sortable-list-custom">
      {items.map((item, index) => {
        return (
        <div
          key={index}
          className="sortable-item d-flex align-items-center justify-content-between gap-2"
          draggable={item.draggable || false}
          onDragStart={() => {
            setHiddenCheckbox(true);
            handleDragStart(index)
          }}
          onDragOver={(e) => e.preventDefault()}
          onDrop={() => handleMoveItem(index)}
          onDragEnd={() => {
            setHiddenCheckbox(false);
            setDragIndex(null)
          }}
        >
          <div className="d-flex align-items-center gap-2">
            <i className={`fa-solid fa-grip-dots-vertical font-size-16 ${!item.draggable ? 'text-color-cinza2' : 'text-color-azul1'}`}></i>
            {!hiddenCheckbox ? <TranspaleStringToComponente
              elementId="select-custom"
              elementProps={{
                value: "",
                type: "Checkbox",
                title: item.header,
                isDisabled: item.disabled,
                field: item.field,
                id: item.field + "_" +index,
                placeholder: "Selecionar coluna",
                checked: !items[index].hidden,
              }}
              onPreFilter={(filters) => {
                const updateItems = items.map((f) => {
                  if (f.field === filters[item.field + "_" +index].field) {
                    f.hidden = !items.find((f) => f.field === filters[item.field + "_" +index].field).hidden;
                  }
                  return f;
                });
                callbackItems(updateItems);
              }}
            /> : <div className="bg-color-cinza2 rounded-2" style={{width: 22, height:22}}></div>}
            <Label className="text-color-cinza5 font-size-14 p-0 m-0">{item.header || 'Funções'}</Label>
          </div>
          <div className="d-flex align-items-center gap-1 cursor-pointer">
            <button className="border-0 p-0 m-0 bg-transparent" disabled={index === 0 || !item.draggable} onClick={() => moveItem(index, index - 1)}>
                <i className={`fa-thin fa-angle-up font-size-16 ${(index === 0 || !item.draggable) ? 'text-color-cinza2': 'text-color-azul1'}`}></i>
            </button>
            <button className="border-0 p-0 m-0 bg-transparent" disabled={index === items.length - 1 || !item.draggable || (!items[index+1].draggable && items[index+1].disabled)} onClick={() => moveItem(index, index + 1)}>
              <i className={`fa-thin fa-angle-down font-size-16 ${(index === items.length - 1 || !item.draggable || (!items[index+1].draggable && items[index+1].disabled)) ? 'text-color-cinza2': 'text-color-azul1'}`}></i>
            </button>
          </div>
        </div>
      )})}
    </div>
  );
};

export default DragDropReorderTable;
